
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-700.5 -241.084)"}},[_c('circle',{attrs:{"data-name":"Ellipse 1","cx":"7.5","cy":"7.5","r":"7.5","transform":"translate(700.5 241.084)","fill":"#243882"}}),_c('path',{attrs:{"data-name":"Path 1147","d":"M704.97 251.764l6.059-6.059","fill":"none","stroke":"#fff","stroke-linecap":"round"}}),_c('path',{attrs:{"data-name":"Path 1146","d":"M704.97 245.705l6.059 6.059","fill":"none","stroke":"#fff","stroke-linecap":"round"}})])])
          )
        }
      }
    